// Copyright (C) 2026 Skylark Drones

import { noVersionApiInstance } from '@/config'

export const releaseProduct = {
  DMO_WEB: 'dmo_web',
  DMO_ANDROID: 'dmo_android'
}

const releaseProductLabels = {
  [releaseProduct.DMO_WEB]: 'DMO Web Portal',
  [releaseProduct.DMO_ANDROID]: 'DMO Android App'
}

export function getReleases(filters = {}) {
  return noVersionApiInstance.publicHttp.get('/product/releases', {
    params: filters
  })
}

export function getLatestRelease(filters = {}) {
  return noVersionApiInstance.publicHttp.get('/product/releases/latest', {
    params: filters
  })
}

export function normalizeRelease(release) {
  return {
    ...release,
    date: release.release_date,
    product: getReleaseProductLabel(release.product)
  }
}

export function normalizeReleases(releases) {
  return releases.map(release => normalizeRelease(release))
}

export function getReleaseProductLabel(product) {
  return product
    .map(product => releaseProductLabels[product] || product)
    .join(' & ')
}

export function isReleaseNewerThanReadRelease(releaseVersion, readVersion) {
  if (!releaseVersion) return false
  if (!readVersion) return true

  return compareReleaseVersions(releaseVersion, readVersion) > 0
}

export function compareReleaseVersions(leftVersion, rightVersion) {
  const leftParts = String(leftVersion).split('.').map(Number)
  const rightParts = String(rightVersion).split('.').map(Number)
  const maxLength = Math.max(leftParts.length, rightParts.length)

  for (let index = 0; index < maxLength; index += 1) {
    const leftPart = leftParts[index] || 0
    const rightPart = rightParts[index] || 0

    if (leftPart !== rightPart) {
      return leftPart > rightPart ? 1 : -1
    }
  }

  return 0
}
